import { Button, Input, Spinner } from '@ss/meta-core-components'
import logo from '@img/MTM-vert-white.svg'
import userIcon from '@img/user-icon.svg'
import lockIcon from '@img/lock-icon.svg'
import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { authState } from '@state'
import { config } from '../../config'

/**
 * Componente Form di login
 * @component
 */
const LoginForm: React.FC<{
  register?: boolean
  setRegister?: (value: boolean) => void
}> = (props) => {
  const { register = false, setRegister } = props

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [, setAuthState] = useAtom(authState)

  const [credential, setCredential] = useState<{
    username: string
    password: string
  }>({ username: '', password: '' })

  const [error, setError] = useState({
    username: false,
    password: false,
  })

  const login = () => {
    if (!credential.username || !credential.password) {
      setError({
        username: !credential.username,
        password: !credential.password,
      })
      return
    }
    setError({ username: false, password: false })
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      if (
        credential.username !== 'infocamere' ||
        credential.password !== 'infocamere'
      ) {
        setError({
          username: true,
          password: true,
        })
        return
      }
      setAuthState({ token: 'token' })
      navigate(config.landingPage)
    }, 1000)
  }

  return (
    <Container>
      <MetaLogo src={logo} />
      <Form data-cy={'login-form'}>
        <InputContainer>
          <Input
            dataCy={'login-form-username'}
            icon={userIcon}
            label={<Label>Username</Label>}
            placeholder={'Username'}
            value={credential.username}
            error={error.username}
            onChange={(value) =>
              setCredential({ ...credential, username: value as string })
            }
          />
        </InputContainer>
        <InputContainer>
          <Input
            dataCy={'login-form-password'}
            icon={lockIcon}
            password
            label={<Label>Password</Label>}
            placeholder={'Password'}
            value={credential.password}
            error={error.password}
            onChange={(value) =>
              setCredential({ ...credential, password: value as string })
            }
          />
        </InputContainer>
        <ButtonContainer>
          <Button onClick={login} dataCy={'login-form-submit'}>
            {loading ? (
              <Spinner data-cy={'login-form-spinner'} />
            ) : (
              <div
                style={{
                  height: 33,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                LOGIN
              </div>
            )}
          </Button>
        </ButtonContainer>
        {register && (
          <RegisterContainer>
            Don't have an account?
            <RegisterLink
              onClick={() => {
                setRegister && setRegister(true)
              }}
            >
              Register
            </RegisterLink>
          </RegisterContainer>
        )}
      </Form>
    </Container>
  )
}

export default LoginForm

//region STYLE
const Container = styled.div`
  place-self: center;
  background: #06223a;
  filter: drop-shadow(-6.22302px -6.22302px 17px #273447)
    drop-shadow(6.22302px 6.22302px 17px #000000);
  border-radius: 20px;
  height: 510px;
  width: 550px;
  display: grid;
  grid-template-rows: 180px auto;
  padding-top: 35px;
  gap: 8px;
  @media (max-width: 745px) {
    width: 440px;
  }
  overflow: hidden;
`
const MetaLogo = styled.img`
  place-self: start center;
  width: 350px;
  height: auto;
`
const Form = styled.div`
  place-self: start center;
  display: grid;
  width: 100%;
  gap: 14px;
  flex-direction: column;
  align-items: center;


  & > input:-webkit-autofill, & > input:-webkit-autofill:hover, & > input:-webkit-autofill:focus, & > input:-webkit-autofill:active {
    background: #06223A;
  !important;
    box-shadow: inset -6.22302px -6.22302px 6.22302px #1e3143, inset 3.73381px 3.73381px 6.22302px #000000 !important;
  }
`
const InputContainer = styled.div`
  width: 350px;
  place-self: center;
  height: 60px;
  padding: 0 18px;
`
const Label = styled.div`
  padding-left: 10px;
`
const ButtonContainer = styled.div`
  place-self: center;
  width: 65%;
  display: grid;
  padding-top: 30px;
`
const RegisterContainer = styled.div`
  place-self: center;
  color: #828282;
  display: flex;
  gap: 15px;
`
const RegisterLink = styled.div`
  cursor: pointer;
`
//endregion
